<script setup>
import WaitlistStatusBadge from './WaitlistStatusBadge.vue'

defineProps({
  deliveries: { type: Array, required: true },
})
</script>

<template>
  <div class="delivery-table">
    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>Status</th>
          <th>Provider</th>
          <th>Message</th>
          <th>Sent</th>
          <th>Failed</th>
          <th>Error</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="delivery in deliveries" :key="delivery.id">
          <td class="vga-mono">{{ delivery.id }}</td>
          <td>
            <WaitlistStatusBadge
              kind="invite"
              :value="delivery.status === 'sent' ? 'sent' : delivery.status === 'pending' ? 'pending' : 'failed'"
              :entry-id="delivery.entry_id"
            />
          </td>
          <td>{{ delivery.provider }}</td>
          <td class="breakable">{{ delivery.message_id }}</td>
          <td>{{ delivery.sent_at }}</td>
          <td>{{ delivery.failed_at }}</td>
          <td class="breakable">{{ delivery.error_message }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
.delivery-table {
  width: 100%;
  overflow-x: auto;
  border: 1px solid var(--drama-color-border);
  border-radius: var(--drama-radius-md);
}

table {
  width: 100%;
  min-width: 900px;
  border-collapse: collapse;
}

th,
td {
  padding: var(--drama-space-md);
  border-bottom: 1px solid var(--drama-color-border);
  text-align: left;
}

th {
  color: var(--drama-color-text-muted);
  font-size: var(--drama-font-size-xs);
}

.breakable {
  max-width: 260px;
  overflow-wrap: anywhere;
}
</style>
